// https://mui.com/material-ui/react-select/
// click "Edit in CodeSandbox" (above the code)
// for imports, etc.

import * as React from 'react';
import Box from '@mui/material/Box';
import { Grid, Paper, Button } from '@mui/material';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import {
    select_userMessage, setUserMessage, setMap
} from 'src/reducers/basicReducer';
import { useDispatch, useSelector } from 'react-redux'

// TODO - consider if this component should be called from another file
import Alpha_slider from "src/components/Dashboard/Map/Alpha_slider"
import Alpha_radio from "src/components/Dashboard/Map/Alpha_radio"

import Slider from '@mui/material/Slider';
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

export default function Variable_selector() {
    const dispatch = useDispatch()

    const change_variable = (event: SelectChangeEvent) => {
        console.log("Setting variable to: " + event.target.value)
        dispatch(setMap({ name: 'variable', value: event.target.value }));
    };

    const change_scenario = (event: SelectChangeEvent) => {
        console.log("Setting scenario to: " + event.target.value)
        dispatch(setMap({ name: 'scenario', value: event.target.value }));
    };

    const change_year = (event: SelectChangeEvent) => {
        console.log("Setting year to: " + event.target.value)
        dispatch(setMap({ name: 'year', value: event.target.value }));
    };

    return (
        // Good explanation of grid sizing (xs, lg, etc.):
        // https://stackoverflow.com/questions/64105244/material-ui-responsive-grid-direction
        <div>
            <Grid container spacing={2} sx={{ bgcolor: 'background.paper', borderRadius: '12px' }}>
                <Grid item lg={3} xs={11.75}>
                    <FormControl fullWidth>
                        <InputLabel id="variable-select-label">Risk variable</InputLabel>
                        <Select
                            labelId="variable-select-label"
                            id="variable"
                            //value={age}
                            defaultValue=""
                            label="Risk variable"
                            onChange={change_variable}
                        >
                            <MenuItem value={'heat'}>Extreme heat</MenuItem>
                            <MenuItem value={'tc'}>Tropical cyclones</MenuItem>
                            <MenuItem value={'wildfire'}>Wildfire activity</MenuItem>
                            <MenuItem value={'sea_level'}>Sea level rise</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item lg={3} xs={11.75}>
                    <FormControl fullWidth>
                        <InputLabel id="scenario-select-label">Emissions scenario</InputLabel>
                        <Select
                            labelId="scenario-select-label"
                            id="scenario"
                            defaultValue=""
                            label="Emissions scenario"
                            onChange={change_scenario}
                        >
                            <MenuItem value={'ssp126'}>SSP1-2.6 (low emissions)</MenuItem>
                            <MenuItem value={'ssp245'}>SSP2-4.5 (intermediate emissions)</MenuItem>
                            <MenuItem value={'ssp585'}>SSP5-8.5 (high emissions)</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item lg={3} xs={11.75}>
                    <FormControl fullWidth>
                        <InputLabel id="year-select-label">Year</InputLabel>
                        <Select
                            labelId="year-select-label"
                            id="year"
                            defaultValue=""
                            label="Year"
                            onChange={change_year}
                        >
                            <MenuItem value={'2020'}>2020</MenuItem>
                            <MenuItem value={'2025'}>2025</MenuItem>
                            <MenuItem value={'2030'}>2030</MenuItem>
                            <MenuItem value={'2035'}>2035</MenuItem>
                            <MenuItem value={'2040'}>2040</MenuItem>
                            <MenuItem value={'2045'}>2045</MenuItem>
                            <MenuItem value={'2050'}>2050</MenuItem>
                            <MenuItem value={'2055'}>2055</MenuItem>
                            <MenuItem value={'2060'}>2060</MenuItem>
                            <MenuItem value={'2065'}>2065</MenuItem>
                            <MenuItem value={'2070'}>2070</MenuItem>
                            <MenuItem value={'2075'}>2075</MenuItem>
                            <MenuItem value={'2080'}>2080</MenuItem>
                            <MenuItem value={'2085'}>2085</MenuItem>
                            <MenuItem value={'2090'}>2090</MenuItem>
                            <MenuItem value={'2095'}>2095</MenuItem>
                            <MenuItem value={'2100'}>2100</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                {/* For Alpha_radio, use lg=3.75 here and 2.75 for others */}
                <Grid item lg={2.95} xs={11.75}>
                    <Alpha_slider />
                    {/* <Alpha_radio /> */}
                </Grid>
            </Grid>
        </div>
    );
}
